// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullRegion,
  $Model,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Input,
  InputGroup,
  InputGroupText,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  getLatestRegionSeasonByRegionId,
} from 'common.helpers/dist/browser';

// Types
import type {
  $ReducerState,
} from '../../../redux';
import type {
  $RedirectAction,
  $SetActiveRegionIdAction,
  $SetActiveRegionSeasonIdAction,
  $ToggleRegionSelectorAction,
} from '../../../redux/modules/main/actions';

export type $OwnProps = $Translate;

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = {
  redirect: $RedirectAction;
  setActiveRegionId: $SetActiveRegionIdAction;
  setActiveRegionSeasonId: $SetActiveRegionSeasonIdAction;
  toggleRegionSelector: $ToggleRegionSelectorAction;
};

type $Props = $DispatchProps & $OwnProps & $StateProps;

class RegionDialogView extends React.Component<$Props> {
  async setRegionId({
    RegionId,
  }: {
    RegionId: string;
  }): Promise<void> {
    const {
      main,
      redirect,
      setActiveRegionId,
      setActiveRegionSeasonId,
      toggleRegionSelector,
    } = this.props;
    const {
      regions,
    } = main;

    try {
      await setActiveRegionId({
        RegionId,
      });

      const latestRegionSeason: $Model<'RegionSeason'> | null = getLatestRegionSeasonByRegionId({
        RegionId,
        regions,
      });

      const RegionSeasonId: null | string = latestRegionSeason !== null
        ? latestRegionSeason.id
        : null;

      if (RegionSeasonId !== null) {
        await setActiveRegionSeasonId({
          RegionSeasonId,
          resetRegatta: true,
        });

        await redirect({
          pathname: '/',
        });

        await toggleRegionSelector(false);
      }
    } catch (err) {
      const error = err as Error;

      ErrorLog.exception(error);
    }
  }

  render() {
    const {
      main,
      t,
    } = this.props;

    const canClose: boolean = main.activeRegionId !== null;

    return (
      <Modal
        backdrop={canClose || 'static'}
        id={'region-dialog'}
        isOpen
        size={'sm'}
      >
        <ModalHeader>
          {t('Please select region')}
        </ModalHeader>
        <ModalBody>
          <InputGroup className={'mb-3'}>
            <InputGroupText>
              <em className={'icon-globe my-1'} />
            </InputGroupText>
            <Input
              id={'region'}
              name={'RegionId'}
              onChange={(e) => this.setRegionId({
                RegionId: e.target.value,
              })}
              type={'select'}
              value={main.activeRegionId || undefined}
            >
              {main.activeRegionId === null && (
                <option />
              )}
              {main.regions.map((item: $FullRegion) => (
                <option
                  key={item.id}
                  value={item.id}
                >
                  {item.Name}
                </option>
              ))}
            </Input>
          </InputGroup>
          <div>
            <span>
              {`${t('Can not find your region?')} `}
            </span>
            <a href={'mailto:Regattas.eu<info@regattas.eu>?subject=Hello'}>
              {t('Contact us')}
            </a>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default RegionDialogView;
